import { render, staticRenderFns } from "./printable.vue?vue&type=template&id=f6bbe890&lang=ja&"
import script from "./printable.vue?vue&type=script&lang=js&"
export * from "./printable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports